import { render, staticRenderFns } from "./ProductRanks.vue?vue&type=template&id=8a5e8f6c&scoped=true&"
import script from "./ProductRanks.vue?vue&type=script&lang=js&"
export * from "./ProductRanks.vue?vue&type=script&lang=js&"
import style0 from "./ProductRanks.vue?vue&type=style&index=0&id=8a5e8f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5e8f6c",
  null
  
)

export default component.exports